import React from "react";
import "./Dashboard.css";
import { Link } from "react-router-dom";
import useDashboard from "../../customHooks/Dashboard/useDashboard";
import SmallLoader from "../../components/SmallLoader/SmallLoader";
import { AiFillShop } from "react-icons/ai";

const Dashboard = () => {
  const hookProps = useDashboard();

  const { stores, handleToggle, loader } = hookProps;
  return (
    <div className="flex">
      <div className="mx-auto p-0 fullwidth">
        <div className="topheader">
          <div className="flex justify-between">
            <span className={`p-1 titlename`}>Stores</span>
          </div>
        </div>
        <div className="middle_main_container">
          {!loader ? (
            <div className="dashboard">
              {stores.map((store, index) => (
                <div key={index} className="tile">
                  <div className="flex items-center justify-center mx-auto p-4">
                    <div>
                      <div className="bg-[#F3F5FF] mx-auto flex items-center justify-center p-4 rounded-xl">
                        <AiFillShop size={30} color="#2E85F7" />
                      </div>
                      <div className="tile-header">
                        <h3 className="store-name">{store.sName}</h3>
                        <div className="relative flex items-center">
                          <input
                            type="checkbox"
                            id={`status-switch-${store?.iStoreId}`}
                            checked={store.bISActive}
                            onChange={() =>
                              handleToggle(store.iStoreId, store.bISActive)
                            }
                            className="sr-only"
                          />
                          <div
                            className={`w-10 h-6 flex items-center rounded-full p-1 cursor-pointer ${
                              store.bISActive ? "bg-green-500" : "bg-gray-300"
                            }`}
                            onClick={() =>
                              handleToggle(store.iStoreId, store.bISActive)
                            }
                          >
                            <div
                              className={`w-4 h-4 bg-white rounded-full shadow-md transform ${
                                store.bISActive
                                  ? "translate-x-4"
                                  : "translate-x-0"
                              }`}
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div className="tile-body">
                    <Link to="/productsandbox" className="info-row">
                      <span className="label">Total Products:</span>
                      <span className="value">{store.iProductsCount}</span>
                    </Link>
                    <Link to="/productsandbox" className="info-row">
                      <span className="label">Pending Products:</span>
                      <span className="value">{store.iMissingImagesCount}</span>
                    </Link>
                    <Link to="/mapbodytype" className="info-row">
                      <span className="label">Missing Body Type:</span>
                      <span className="value">{store.iNoBodyTypeCount}</span>
                    </Link>
                  </div>
                </div>
              ))}
            </div>
          ) : (
            <div className="screenTableRootLoader">
              <SmallLoader />
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default Dashboard;
